/** #@condition: experimentalBanners **/
import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {PRIORITY} from '#core/application/abstract-feature.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {HeaderComponent} from './header-component.jsx';

class ExperimentalBannersFeature extends AbstractVisualFeature {
    get name() {
        return 'Experimental Banners';
    }

    get priority() {
        return PRIORITY.LAST;
    }

    updateViewsConfig(viewsConfig) {
        if (!isMobile()) {
            mergeTo(viewsConfig, {
                HomePageClassic: {
                    topPromotionsContainer: {
                        style: {
                            display: 'none',
                        },
                    },
                    topBannerPromotions: {
                        locationId: null,
                    },
                },
            });
        } else {
            mergeTo(viewsConfig, {
                HomePageClassic: {
                    topPromotionsContainer: {
                        style: {
                            display: 'flex',
                            width: '100%',
                        },
                    },
                    topBannerPromotions: {
                        view: {
                            swiper: {
                                loop: false,
                                autoPlay: false,
                                centerViewableSlide: false,
                                lazyLoadBufferSize: 2,
                                minViewableBufferSize: 2,
                                style: {
                                    _mobile_gap: '8px',
                                    padding: '2px 8px',
                                    scrollPaddingLeft: '8px',
                                    scrollPaddingRight: '8px',
                                },
                                slide: {
                                    style: {
                                        overflow: 'hidden',
                                        height: '220px',
                                        _mobile_flexBasis: '160px',
                                        borderRadius: '8px',
                                        _mobile_maxWidth: '160px',
                                    },
                                },
                            },
                            banner: {
                                bannerMarket: {
                                    participants: {
                                        width: '100%',
                                        _mobile_width: '100%',
                                        minWidth: 'auto',
                                    },
                                    market: {
                                        container: {
                                            style: {
                                                _mobile_width: '100%',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            });
        }

        return super.updateViewsConfig(viewsConfig);
    }

    updateMojitoConfig(mojitoConfig) {
        if (!isMobile()) {
            const viewImplementations = ensureHierarchy(mojitoConfig, 'services.viewImplementations');
            mergeTo(viewImplementations, {
                ApplicationHeader: {
                    implementation: HeaderComponent,
                },
            });
        }
        super.updateMojitoConfig(mojitoConfig);
    }
}

new ExperimentalBannersFeature(allVisuals);
